export function findQuantityChanges(arr1, arr2) {
  const changes = [];
  const map = new Map();

  // Create a map from the first array
  arr1.forEach((item) => map.set(item.ean, item.quantity));

  // Compare with the second array
  arr2.forEach((item) => {
    if (map.has(item.ean)) {
      const quantityDifference = item.quantity - map.get(item.ean);
      if (quantityDifference !== 0) {
        changes.push({
          ean: item.ean,
          change: quantityDifference,
          styleId: item.productId,
          variantId: item.variantId,
        });
      }
    } else {
      // If the item in arr2 is not found in arr1, consider it a new addition
      changes.push({
        ean: item.ean,
        change: item.quantity,
        styleId: item.styleId,
        variantId: item.variantId,
      });
    }
  });

  return changes;
}
